/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PwC Web App Accelerator API
 * OpenAPI spec version: 1.0
 */

export type RuleImportMode =
    (typeof RuleImportMode)[keyof typeof RuleImportMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleImportMode = {
    NUMBER_0: 0,
    NUMBER_1: 1,
} as const;
